const ListingDeliveryStatus = Object.freeze({
  Delivered: {
    name: 'Listing Delivered',
    value: 'delivered',
    color: 'success-lightest',
  },
  Undelivered: {
    name: 'Listing Undelivered',
    value: 'undelivered',
    color: 'danger-lightest',
  },
  Scheduled: {
    name: 'Listing Scheduled',
    value: 'scheduled',
    color: 'warning-lightest',
  },
})

export default ListingDeliveryStatus
